  export function slider() {

    //const indexPersonSlide = document.querySelector('.indexPersonSlide');
    // if(indexPersonSlide) {
    //   const swiper = new Swiper(".indexPersonSlide", {
    //     loop: true,
  
    //     // ページネーション（スライダーの位置を示す丸いドット）用の要素を指定
    //     pagination: {
    //       el: ".swiper-pagination",
    //     },
  
    //     // 矢印ボタン用の要素を指定
    //     navigation: {
    //       nextEl: ".swiper-button-next",
    //       prevEl: ".swiper-button-prev",
    //     },
    //   });
    // }

    
  const indexPersonSlide = document.querySelector('.indexPersonSlide');
  if(indexPersonSlide) {
    const swiperSlides = document.getElementsByClassName("swiper-slide");
    const breakPoint = 767; // ブレークポイントを設定
    let swiper;
    let swiperBool;
    
    window.addEventListener(
      "load",
      () => {
        if (breakPoint < window.innerWidth) {
          swiperBool = false;
        } else {
          createSwiper();
          swiperBool = true;
        }
      },
      false
    );

    window.addEventListener(
      "resize",
      () => {
        if (breakPoint < window.innerWidth && swiperBool) {
          swiper.destroy(false, true);
          swiperBool = false;
        } else if (breakPoint >= window.innerWidth && !swiperBool) {
          createSwiper();
          swiperBool = true;
        }
      },
      false
    );

    const createSwiper = () => {
      swiper = new Swiper(".indexPersonSlide", {
        loop: true, // ループさせる
        slidesPerView: 1.3, // 一度に表示する枚数
        spaceBetween: 30, // スライド間の距離
        centeredSlides: true,
        //speed: 3000, // ループの時間
        //allowTouchMove: false, // スワイプ無効
        // autoplay: {
        //   delay: 0, // 途切れなくループ
        // },
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // クリック可能にする
        },
        // 前後の矢印
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    };
  }

  const interviewElder_bnr_slide = document.querySelector('.interviewElder_bnr_slide');
  if(interviewElder_bnr_slide) {
    const swiperSlides = document.getElementsByClassName("swiper-slide");
    const breakPoint = 767; // ブレークポイントを設定
    let swiper;
    let swiperBool;
    
    window.addEventListener(
      "load",
      () => {
        if (breakPoint < window.innerWidth) {
          swiperBool = false;
        } else {
          createSwiper();
          swiperBool = true;
        }
      },
      false
    );

    window.addEventListener(
      "resize",
      () => {
        if (breakPoint < window.innerWidth && swiperBool) {
          swiper.destroy(false, true);
          swiperBool = false;
        } else if (breakPoint >= window.innerWidth && !swiperBool) {
          createSwiper();
          swiperBool = true;
        }
      },
      false
    );

    const createSwiper = () => {
      swiper = new Swiper(".interviewElder_bnr_slide", {
        loop: true, // ループさせる
        slidesPerView: 1.5, // 一度に表示する枚数
        spaceBetween: 50, // スライド間の距離
        centeredSlides: true,
        // speed: 8000, // ループの時間
        // allowTouchMove: false, // スワイプ無効
        // autoplay: {
        //   delay: 0, // 途切れなくループ
        // },
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // クリック可能にする
        },
        // 前後の矢印
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    };
  }
}